// extracted by mini-css-extract-plugin
export var heroImage = "_m6-1";
export var modal = "_m6-0";